import { render, staticRenderFns } from "./download.vue?vue&type=template&id=2dfbbcae&scoped=true"
import script from "./download.vue?vue&type=script&lang=ts"
export * from "./download.vue?vue&type=script&lang=ts"
import style0 from "./download.vue?vue&type=style&index=0&id=2dfbbcae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfbbcae",
  null
  
)

export default component.exports